import { Container } from "./style";
import { Error } from "../../styles/global";

const Email = ({ inputRef, error, name, label, value, onChange }) => {
  return (
    <Container>
      <label>
        {label ? label : "Confirme seu E-mail (mesmo utilizado no login)"}
      </label>
      <legend>
        {label
          ? ""
          : "Caso seu e-mail não seja preenchido automaticamente, favor informar!"}
      </legend>
      <input
        ref={inputRef}
        name={name}
        value={value}
        onChange={onChange}
        placeholder="Insira seu email"
      />
      <Error>{error}</Error>
    </Container>
  );
};

export default Email;
